import React from "react";
import styled from "styled-components";

import { Flex } from "../../../components/Flex";
import { Text } from "../../../components/Text";
import { Rounded } from "../../../theme/Rounded";
import { Spacing } from "../../../theme/Spacing";
import { ThemeType } from "../../../theme/Theme";
import { formatReportPercent } from "../../../utils/Reports";
import { ReportCard } from "./ReportCard";

const Bar = styled.div`
  width: 100%;
  height: 0.85rem;
  min-height: 0.85rem;
  flex-shrink: 0;
  border-radius: ${Rounded.md};
  background-color: ${({ theme }) => theme.sub};
  overflow: hidden;
`;

const Fill = styled.div<{ share: number; tone: keyof ThemeType }>`
  width: ${({ share }) => Math.round(share * 100)}%;
  height: 100%;
  background-color: ${({ theme, tone }) => theme[tone]};
  transition: width 0.2s ease;
`;

const Container = styled(ReportCard)`
  min-width: 12rem;
`;

type Props = {
  title: string;
  hint: string;
  /** Null when the denominator was zero — no rate exists, rather than 0%. */
  value: number | null;
  tone?: keyof ThemeType;
};

export const ReportRateTile: React.FC<Props> = ({
  title,
  hint,
  value,
  tone = "main",
}) => (
  <Container>
    <Flex alignItems="baseline" gap="s" justifyContent="space-between">
      <Text fontWeight="bold">{title}</Text>
      <Text fontSize="l" color={value === null ? "darkerSub" : tone}>
        {value === null ? "—" : `${formatReportPercent(value)}%`}
      </Text>
    </Flex>
    <Bar>
      <Fill share={value ?? 0} tone={tone} />
    </Bar>
    <Text fontSize="s" color="darkerSub">
      {hint}
    </Text>
  </Container>
);
